export const GET_STUDENT_COMMENTS_FILTERS = 'GET_STUDENT_COMMENTS_FILTERS'
export const GET_STUDENT_COMMENTS_GRID = 'GET_STUDENT_COMMENTS_GRID'
export const GET_STUDENT_COMMENTS_ROW = 'GET_STUDENT_COMMENTS_ROW'
export const CREATE_STUDENT_COMMENT = 'CREATE_STUDENT_COMMENT'
export const UPDATE_STUDENT_COMMENT = 'UPDATE_STUDENT_COMMENT'
export const DELETE_STUDENT_COMMENT = 'DELETE_STUDENT_COMMENT'
